import React, { createContext, useState } from 'react';
import Cms from './guest/Cms';
import fetchCMS, {setUserInfoToLocal, getUserInfoFromLocal, fetchFAQ, fetchSocialMedia, fetchConfigData } from './apis';
import { map, Observable, of } from 'rxjs';
import { SocialMedia } from './App';
import { Faq } from './guest/Faq';
import { UserInfo } from './Models';

interface GlobalState {
  getOrLoadConfigData: () => Observable<any>;
  getOrLoadCMSRecord: (key: string) => Observable<Cms>;
  getOrLoadSocialMedia: () => Observable<SocialMedia[]>;
  getOrLoadFAQs: () => Observable<Faq[]>;
  setUserInfo: (userInfo: UserInfo | null) => void;
  getUserInfo: () => Observable<UserInfo | null>;
}
export const GlobalContext = createContext<GlobalState | null>(null);

export const GlobalProvider = ({ children }: any) => {

  const [configRecord, setConfigRecord] = useState<any>(null);
  const [cmsRecord, setCMSRecord] = useState<Record<string, Cms>>({});
  const [socialMediaRecord, setSocialMediaRecord] = useState<SocialMedia[]>([]);
  const [faqRecord, setFaqRecord] = useState<Faq[]>([]);
  const [userInFoLocal, setUserInFoLocal] = useState<UserInfo | null>(() => {
    const stored = localStorage.getItem("_qm-login-info");
    return stored ? JSON.parse(stored) : null;
  });

  const getOrLoadConfigData = (): Observable<any> => {
    
    if (configRecord) {
      return of(configRecord);
    }
    return fetchConfigData().pipe(map((config)=> {
      
        if(config) {
          setConfigRecord(config);
        }
        return config;
    }));
  };
  
  const getOrLoadCMSRecord = (key: string): Observable<Cms> => {
    if (cmsRecord[key]) {
      return of(cmsRecord[key]);
    }
    return fetchCMS(key).pipe(map((recordData)=> {
        if(recordData) {
          setCMSRecord(prev => ({ ...prev, [key]: recordData }));
        }
        return recordData;
    }));
  };
  
  const getOrLoadSocialMedia = (): Observable<SocialMedia[]> => {

    if (socialMediaRecord.length > 0) {
      return of(socialMediaRecord);
    }

    return fetchSocialMedia().pipe(map((socialMedia)=> {
        if(socialMedia && socialMedia.length > 0) {
          setSocialMediaRecord(socialMedia);
        }
        return socialMedia;
    }));
  };

  const getOrLoadFAQs = (): Observable<Faq[]> => {

    if (faqRecord.length > 0) {
      return of(faqRecord);
    }

    return fetchFAQ().pipe(map((FAQs)=> {
        if(FAQs && FAQs.length > 0) {
          setFaqRecord(FAQs);
        }
        return FAQs;
    }));
  };

  const setUserInfo = (userInfo: UserInfo | null): void => {
    setUserInfoToLocal(userInfo);
    setUserInFoLocal(userInfo);
  };

  const getUserInfo = (): Observable<UserInfo | null> => {
    return of(userInFoLocal);
  };

  return (
    <GlobalContext.Provider value={{
    getOrLoadConfigData,
    getOrLoadCMSRecord, 
    getOrLoadSocialMedia, 
    getOrLoadFAQs, 
    setUserInfo,
    getUserInfo
    }}>
      {children}
    </GlobalContext.Provider>
  );
};